import dayjs, { type Dayjs } from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)
// Функция парсинга строки в dayjs с проверкой формата
export const parseDateStringToDayjsDate = (str: string): Dayjs =>
  dayjs(str, 'YYYY-MM-DD', true).isValid()
    ? dayjs(str, 'YYYY-MM-DD', true)
    : dayjs()

export const parseDateStringToDayjsTime = (str: string): Dayjs => {
  const dt = dayjs(str)
  return dayjs()
    .set('hour', dt.hour())
    .set('minute', dt.minute())
    .set('second', dt.second())
    .set('millisecond', dt.millisecond())
    .startOf('second')
}

// Функция форматирования dayjs в строку 'YYYY-MM-DD'
export const formatDayjsToDateString = (date: Dayjs): string =>
  date.format('YYYY-MM-DD')

// Функция форматирования dayjs в строку 'YYYY-MM-DDTHH:mm:ss.SSSZ'
export const formatDayjsToDateTimeString = (
  date: Dayjs,
  time: Dayjs,
): string => {
  const formattedDate = formatDayjsToDateString(date)
  const formattedTime = time.format('HH:mm:ss.SSSZ')
  return `${formattedDate}T${formattedTime}`
}

// Функция форматирования строки 'YYYY-MM-DDTHH:mm:ss.SSSZ' в строку 'YYYY-MM-DD HH:mm:ss'
export const formatDateTimeStringToDateString = (
  str: string,
  utc: boolean = true,
): string => dayjs(str).utc(utc).format('YYYY-MM-DD HH:mm:ss')
